export default __webpack_public_path__ + "static/bb2-65f631dc14b33a07fa3599e9960f337f.jpeg";